import { createContext, ReactNode, useContext } from "react";
import { Hits } from "../../../types/Paginated";

type PaginationContextType = {
  pageData: any[];
  onPageChange: (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => void;
  count: Hits;
  pageIndex: number;
  pageSize: number;
};

const PaginationContext = createContext<PaginationContextType | undefined>(
  undefined,
);

type PaginationProviderProps = {
  value: PaginationContextType;
  children: ReactNode;
};

export const PaginationProvider = ({
  value,
  children,
}: PaginationProviderProps) => {
  return (
    <PaginationContext.Provider value={value}>
      {children}
    </PaginationContext.Provider>
  );
};

export const usePaginationContext = () => {
  const context = useContext(PaginationContext);
  if (!context) {
    throw new Error(
      "usePaginationContext must be used within a PaginationProvider",
    );
  }
  return context;
};
